import { useContext, useEffect, useRef } from "react";
import type { FC } from "react";
import { Invoice } from "@common/types/invoice";
import { PaginatedInvoicesTableContext } from "./PaginatedInvoicesTable.context";

interface InvoiceAutoSelectorProps {
    initialIds: string[];
    onSelect: (invoice: Invoice) => void;
}

export const InvoiceAutoSelector: FC<InvoiceAutoSelectorProps> = ({
    initialIds,
    onSelect,
}) => {
    const { invoices } = useContext(PaginatedInvoicesTableContext);
    const handledRef = useRef(false);

    useEffect(() => {
        if (handledRef.current || !invoices?.length) {
            return;
        }
        const match = invoices.find((inv) => initialIds.includes(inv.id));
        if (match) {
            handledRef.current = true;
            onSelect(match);
        }
    }, [invoices, initialIds, onSelect]);

    return null;
};
